import Image from "next/image"
import Link from "next/link"
import { SEARCH_PARAMS_FF_SEARCH_PARAMS } from "@/constants/ui"

import { determineCardPrices } from "@/lib/price-utils"
import { ReducedProductData } from "@/lib/storefront/product/product"
import { showProductPrice } from "@/lib/storefront/product/productHelper"
import ProductCardDiscount from "@/components/product/ProductCardDiscount"
import ProductCardPrice from "@/components/product/ProductCardPrice"

import { getResizedSbImagepath } from "../ui/helpers/resize-sb-image"

export default function ProductCardLandscape(props: {
  productData: ReducedProductData | undefined
  /*
  standardVariant: ReducedProductData | undefined
*/
  showDescription: boolean | undefined
  prices: any
  isB2BCustomer: boolean
  isoLocale: string
  inStoryBlok: boolean
  ffSearchParamsEncrypted?: string
}) {
  const cardPrices = determineCardPrices(props.isoLocale, props.isB2BCustomer, props.prices)
  const { showPrice } = showProductPrice(props.productData, cardPrices)

  return (
    <>
      {props.productData ? (
        <Link
          prefetch={false}
          className="size-full @container/productcard"
          href={(function () {
            let href = props.productData?.link ?? ""
            const appendParam = (url: string, key: string, value: string | number | boolean | null | undefined) => {
              if (value === undefined || value === null || value === "") return url
              const sep = url.includes("?") ? "&" : "?"
              return `${url}${sep}${key}=${encodeURIComponent(String(value))}`
            }
            href = appendParam(href, SEARCH_PARAMS_FF_SEARCH_PARAMS, props.ffSearchParamsEncrypted)
            return href
          })()}
        >
          <ProductCardDiscount
            isoLocale={props.isoLocale}
            product={props.productData}
            variant={"landscape"}
            prices={props.prices}
            isB2BCustomer={props.isB2BCustomer}
            legacyPrices={true}
          />
          {/*inner main div*/}
          <div className="flex h-full flex-1 grow flex-row justify-between gap-2 p-2 2xl:p-4">
            {/*top half*/}
            <div className="flex w-1/3 flex-col items-center justify-center gap-2">
              {/*image*/}
              <div className={"flex items-center"}>
                {props.productData.image ? (
                  <Image
                    unoptimized={true}
                    className="aspect-square max-h-20 overflow-hidden object-contain"
                    alt={props.productData.title}
                    src={getResizedSbImagepath(props.productData.image)}
                    width={props.productData.image_width}
                    height={props.productData.image_height}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className={"flex w-2/3 flex-col items-end justify-between gap-1"}>
              {/*title*/}
              <div className={"flex w-full justify-start"}>
                <p className="line-clamp-2 min-h-8 text-sm font-bold leading-tight text-gray-900">
                  {props.productData.title}
                </p>
              </div>
              {/*description*/}
              {props.showDescription && (
                <div
                  className={"prose-xs line-clamp-2 hidden w-full grow justify-start text-xs leading-tight 2xl:flex"}
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: props.productData.description ? props.productData.description : "",
                    }}
                  />
                </div>
              )}

              {/*right half*/}
              <div className="flex flex-col justify-end gap-2">
                {/*prices and buttons*/}
                <ProductCardPrice
                  isoLocale={props.isoLocale}
                  showEcoTaxFlag={false}
                  productData={props.productData}
                  cardPrices={cardPrices}
                  isB2BCustomer={props.isB2BCustomer}
                  showPrice={showPrice}
                />
              </div>
            </div>
          </div>
        </Link>
      ) : (
        <>{props.inStoryBlok && <p>Product not found</p>}</>
      )}
    </>
  )
}
